/* eslint-disable indent */
/* eslint-disable quotes */
/* eslint-disable space-before-function-paren */
const env = process.env
const service = require("@/assets/js/request")
const setmeta = {
  data() {
    return {
      setting: {
        web_title: env.TITLE,
        keywords: env.KEYWORDS,
        description: env.DESCRIPTION,
        copyright: env.TITLE + " " + env.COPYRIGHT
      },
      qrcodeUrl: ""
    }
  },
  methods: {
    setMetaConfig(option = {}) {
      this.setting = Object.assign(this.setting, option)
    },
    getSystemConfig() {
      service
        .request({
          method: "POST",
          url: "getSystemConfig",
          params: {}
        })
        .then(res => {
          // this.setMetaConfig(res.data)
          this.setting["web_title"] = this.$env["TITLE"] = res.data.title
          this.setting["description"] = this.$env["DESCRIPTION"] = res.data.description
          this.setting["keywords"] = this.$env["KEYWORDS"] = res.data.keywords
          this.setting["copyright"] = res.data.title + " " + env.COPYRIGHT
          this.setMetaConfig()
        })
        .catch(err => {
          service.error(err, {
            that: this
          })
        })
    }
  },
  metaInfo() {
    return {
      title: this.setting.web_title,
      meta: [
        {
          name: "keywords",
          content: this.setting.keywords
        },
        {
          name: "description",
          content: this.setting.description
        },
        {
          name: "copyright",
          content: this.setting.copyright
        }
      ]
    }
  }
}

export { setmeta }



// WEBPACK FOOTER //
// ./src/assets/js/setmeta.js